// src/modules/inpatients/components/modals/AddOrderModal.jsx
import { useEffect, useState } from "react";
import Modal from "../shared/Modal";
import { Field, Select, DateInput, TextArea } from "../shared/FormFields";
import { PrimaryButton, SecondaryButton } from "../shared/Buttons";
import { staffOptions } from "../../data/mockData";

const ORDER_TYPES = ["Medication", "Lab Test", "Radiology", "Procedure", "Nursing Care", "Diet", "Consultation", "Blood Bank"];
const PRIORITIES = ["High", "Medium", "Low"];

const EMPTY = {
  orderType: "",
  orderName: "",
  priority: "Medium",
  orderDate: "",
  orderedBy: staffOptions.doctors[0],
  department: "",
  notes: "",
};

export default function AddOrderModal({ open, onClose, onSave, initialData }) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (open) setForm(initialData || EMPTY);
  }, [open, initialData]);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));
  const isValid = form.orderType && form.orderName && form.orderDate && form.orderedBy;

  const handleSubmit = () => {
    if (!isValid) return;
    onSave({ ...form, id: initialData?.id });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={initialData ? "Edit Order" : "Add Order"}
      footer={
        <>
          <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
          <PrimaryButton onClick={handleSubmit} disabled={!isValid}>Save Order</PrimaryButton>
        </>
      }
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Field label="Order Type" required>
          <Select value={form.orderType} onChange={set("orderType")}>
            <option value="">Select Order Type</option>
            {ORDER_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </Select>
        </Field>
        <Field label="Order Name / Test / Procedure" required>
          <Select value={form.orderName} onChange={set("orderName")}>
            <option value="">Search and select</option>
            <option value="IV Fluids (Normal Saline)">IV Fluids (Normal Saline)</option>
            <option value="CBC (Complete Blood Count)">CBC (Complete Blood Count)</option>
            <option value="Chest X-Ray (PA View)">Chest X-Ray (PA View)</option>
            <option value="ECG">ECG</option>
          </Select>
        </Field>

        <Field label="Priority">
          <Select value={form.priority} onChange={set("priority")}>
            {PRIORITIES.map((p) => <option key={p} value={p}>{p}</option>)}
          </Select>
        </Field>
        <Field label="Order Date" required>
          <DateInput value={form.orderDate} onChange={set("orderDate")} />
        </Field>

        <Field label="Ordered By" required>
          <Select value={form.orderedBy} onChange={set("orderedBy")}>
            {staffOptions.doctors.map((d) => <option key={d} value={d}>{d}</option>)}
          </Select>
        </Field>
        <Field label="Department / Category">
          <Select value={form.department} onChange={set("department")}>
            <option value="">Select Department</option>
            {staffOptions.departments.map((d) => <option key={d} value={d}>{d}</option>)}
          </Select>
        </Field>

        <Field label="Clinical Indication / Notes" className="sm:col-span-2">
          <TextArea placeholder="Enter clinical indication or notes (optional)" maxLength={250} rows={3} value={form.notes} onChange={set("notes")} />
        </Field>
      </div>
    </Modal>
  );
}
